module.exports = function (data) {
    return {
        event: 'BWSHelpSiteSearch',
        eventContext: {
            area: "help-centre",
            searchTerm: data.searchTerm,
            linkName: data.linkName // Pass through the search-specific link name
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/helpsite-search-mapper.js
 **/